var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "table__row table__row--mobile-pad" }, [
    _c("td", { staticClass: "table__cell--description" }, [
      _vm._v(_vm._s(_vm.transaction.description))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table__cell--date" }, [
      _vm._v(_vm._s(_vm.transaction.date))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table__cell--amount" }, [
      _c("span", { class: _vm.transactionClass }, [
        _vm._v(_vm._s(_vm.transaction.amount))
      ])
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table__cell table__cell--action" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }